module.exports = __webpack_public_path__ + "img/mstile-310x310.49b40d7c.png";